import "./style.scss";
import Logo from "./img/ic-logo.svg?react";
import BatLogo from "./img/bat-logo.svg?react";
import { useLocation } from "react-router-dom";
import Fb from "./img/fb.svg?react";
import Ig from "./img/ig.svg?react";
import Mail from "./img/mail.svg?react";
import Glo from "./img/glo.svg?react";
import GloW from "./img/gloW.svg?react";
import { useEffect, useState } from "react";

const footerLinks = [
  {
    name: "Kontakt",
    href: "/contact",
  },
  {
    name: "FAQ",
    href: "/about/faq",
  },
  {
    name: "Allgemeine Bestimmungen",
    href: "/terms",
  },
  // {
  //   name: "Cookie-Politik",
  //   href: `${import.meta.env.VITE_API_URL}/terms/cookie-policy`,
  //   target: "_blank",
  // },
  {
    name: "Cookie-Einstellungen",
    // onClick: () => NiceModal.show("cookies-modal"),
  },
  {
    name: "Datenschutzbestimmungen",
    href: `${import.meta.env.VITE_API_URL}/terms/privacy-policy`,
    target: "_blank",
  },
];

const year = new Date().getFullYear();

export default function Footer() {
  const location = useLocation();
  const isUltraInsider =
    location.pathname.includes("/subscription") ||
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  const isQrScanner =
    location.pathname.startsWith("/qr-scanner") ||
    location.pathname.startsWith("/qr-register");

  const [activeSkin, setActiveSkin] = useState(() => {
    const stored = localStorage.getItem("activeSkin");
    return stored || null;
  });

  useEffect(() => {
    const updateSkin = () => {
      const stored = localStorage.getItem("activeSkin");
      setActiveSkin(stored || null);
    };

    window.addEventListener("skinChange", updateSkin);
    return () => window.removeEventListener("skinChange", updateSkin);
  }, []);

  return (
    <footer
      className={`footer ${isUltraInsider || isQrScanner ? "ultra-insider" : ""} ${activeSkin && !isUltraInsider && !isQrScanner ? `skin-${activeSkin}` : ""}`}
    >
      <ul className="footer-nav">
        <li className="logo">
          <Logo />
        </li>
        {footerLinks.map((link, index) =>
          link.href ? (
            <li key={index}>
              <a
                href={link.href}
                target={link.target ? link.target : ""}
                rel="noopener noreferrer"
                key={link.name}
              >
                <span className="footer-link" key={link.name}>
                  {link.name}
                </span>
              </a>
            </li>
          ) : (
            <li key={index}>
              <p className="footer-link" key={link.name}>
                <button id="ot-sdk-btn" className="ot-sdk-show-settings">
                  {link.name}
                </button>
              </p>
            </li>
          ),
        )}
      </ul>
      <div className="bottom">
        <div className="brand">
          <div className="bat-logo">
            <BatLogo />
          </div>
          <p className="copyright">
            ©British American Tobacco {year}. Alle Rechte vorbehalten.
          </p>
        </div>
        <div className="des-wrapper">
          <div className="des-contact">
            Schreib uns: <Mail /> service@bat.de
          </div>
          <div className="desc-social">
            <div className="des-icons">
              Finde uns auf:
              <a className="footer-icon glo">
                {isUltraInsider ||
                isQrScanner ||
                ["mclaren2025"].includes(activeSkin) ? (
                  <GloW />
                ) : (
                  <Glo />
                )}
              </a>
              <a
                href="https://www.facebook.com/glo.germany/ "
                target="_blank"
                rel="noopener noreferrer"
                className="footer-icon fb"
              >
                <Fb />
              </a>
              <a
                href="https://www.instagram.com/glo.germany/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-icon ig"
              >
                <Ig />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
